import React from "react";
import "./Projects.css";
import { FaReact, FaHardHat } from "react-icons/fa";
import {
  SiBlockchaindotcom,
  SiHtml5,
  SiMaterialui,
  SiChai,
  SiEthereum,
  SiExpress,
  SiSocketdotio,
  SiTailwindcss,
  SiReactrouter,
  SiJavascript,
  SiMongodb,
  SiNodedotjs
} from "react-icons/si";
import { DiCss3 } from "react-icons/di";
import { VscJson } from "react-icons/vsc";
import { IoLogoJavascript } from "react-icons/io";
export const Projects = () => {
  return (
    <>
      <div className="section">
        <h2 className="section__title different" data-aos="fade-right"   style={{paddingTop:120}}>
          Projects
        </h2>

{/* ************************************ Mytheresa ****************************************** */}
<div className="projects_container">
          <div className="project">
            <div className="project_videocontainer">
              <div data-aos="fade-right">
                <img
                src="https://i.ibb.co/6vGRp1z/Screenshot-2022-07-14-015200.jpg"
                  alt="Mytheresa"
                />
              </div>
            </div>
            <div className="project_information" data-aos="fade-right">
              <h2>Mytheresa-clone</h2>
              <p>
            Clone of popular E-commerce website, built using Mern in 5 days
              </p>
              <div>
                {/* <IoLogoJavascript /> */}
                <FaReact />
                <SiHtml5 />
                <DiCss3 />
                 <SiNodedotjs />
                <SiExpress />
                <SiMongodb /> 
              </div>



              <div>
                <a
                  href="https://mytheresa-vineethevk.vercel.app/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline onbt">
                    See this Live
                  </span>
                </a>
                <a
                  href="https://github.com/vineethevk/Mytheresa"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline">
                    View Code
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>


{/* **************************** Udemy ************************************** */}


        <div className="projects_container">
          <div className="project">
            <div className="project_videocontainer">
          <div data-aos="fade-right"> 
                <img
                  src="https://ashish-kumar-mohanty-portfolio.vercel.app/static/media/udemy.73ddc57b621a982f0977.png"
                  alt="Mail Chimp"
                />
              </div> 
           </div> 
        <div className="project_information" data-aos="fade-right">
              <h2>Udemy-Clone</h2>
              <p>
                Clone of the popular e-Learning  website Udemy . Built with Javascript css and Html in 5 days.
              </p>
              <div>
                {/* <FaReact /> */}
                <SiHtml5 />
                <DiCss3 />
                <IoLogoJavascript />
                 <SiNodedotjs /> 
               <SiExpress /> 
                 <SiMongodb /> 
              </div>
              <div>
                <a
                  href="https://cloneudemy.netlify.app/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline onbt">
                    See this Live
                  </span>
                </a>
                <a
                  href="https://github.com/Ashish240399/Udemy_Clone"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline">
                    View Code
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div> 

{/*           ---------------------------------- weather app  ------------------------*/}

        <div className="projects_container">
          <div className="project">
            <div className="project_videocontainer">
              <div data-aos="fade-right">
                <img
                src="https://i.ibb.co/NnMGqFq/weather.png"
                  alt="Weather"
                />
              </div>
            </div>
            <div className="project_information" data-aos="fade-right">
              <h2>Weather App</h2>
              <p>
               Real time weather app having feacture to show real time weather report sunset 
              </p>
              <div>
                {/* <IoLogoJavascript /> */}
                <FaReact />
                <SiHtml5 />
                <DiCss3 />
                {/* <SiNodedotjs />
                <SiExpress />
                <SiMongodb /> */}
              </div>



              <div>
                <a
                  href="https://weather-app-xi-three.vercel.app/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline onbt">
                    See this Live
                  </span>
                </a>
                <a
                  href="https://github.com/Hariom1711/Weather-App.git"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline">
                    View Code
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
                {/* -------------------------------------------------------------todo App--------------------------------------------------- */}
        <div className="projects_container">
          <div className="project">
            <div className="project_videocontainer">
              <div data-aos="fade-right">
                <img

src="https://i.ibb.co/pd3H8Rs/Screenshot-2022-07-11-163117.png"

alt=""
                />
              </div>
            </div>

            <div className="project_information" data-aos="fade-right">
              <h2>ToDo App </h2>
              <p>
               Mini ToDo App  project having features to add delete and update data , data do not  lost after refreshing the page.
              </p>
              <div>
              <FaReact />
                <SiHtml5 />
                <DiCss3 />
              </div>
              <div>
                <a
                  href="http://todo-app-ten-snowy.vercel.app/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline onbt">
                    See this Live
                  </span>
                </a>
                <a
                  href="https://github.com/Hariom1711/Todo-App.git"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline">
                    View Code
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
                {/* ----------------------------Tic-TacToe------------------------------ */}
       
       
        <div className="projects_container">
          <div className="project">
            <div className="project_videocontainer">
              <div data-aos="fade-right">
                <img
                src="https://i.ibb.co/bFXrpMS/Screenshot-2022-05-07-160809.png"
                  alt="Resturent"
                />
              </div>
            </div>




            <div className="project_information" data-aos="fade-right">
              <h2>Classic Resturent</h2>
              <p>
                Mini project of A classic Resturent App built using ReactJS. Features : Can filter the item on basis of breakfast evening dinner etc. if we add other category of food it will directly come with new category in navbar.
              </p>
              <div>
                <FaReact />
                <SiHtml5 />
                <DiCss3 />
              </div>
              <div>
                <a
                  href="https://restaurants-app-zeta.vercel.app/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline onbt">
                    See this Live
                  </span>
                </a>
                <a
                  href="https://github.com/Hariom1711/Restaurants-App.git"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline">
                    View Code
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="projects_container">
          <div className="project">
            <div className="project_videocontainer">
              <div data-aos="fade-right">
                <img
                  src="https://i.ibb.co/PMny3hW/Screenshot-406.png"
                  alt="TicTacToe"
                />
              </div>
            </div> */}
{/*  --------------------------------   star war -----------------------------        */}

            {/* <div className="project_information" data-aos="fade-right">
              <h2>Star Wars Search</h2>
              <p>
                Vanilla JS web app to Search for any Star Wars Character. Build with the help of Star Wars API and has the Classic UI (Color theme) of the original Star Wars Movie. Built to learn APIs and use them in the project.
              </p>
              <div>
                <SiHtml5 />
                <DiCss3 />
                <IoLogoJavascript />
              </div>
              <div>
                <a
                  href="https://star-war-om.netlify.app"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline onbt">
                    See this Live
                  </span>
                </a>
                <a
                  href="https://github.com/Hariom1711/Star-war"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span type="button" className="btn btn--outline">
                    View Code
                  </span>
                </a>
              </div> */}
            {/* </div> */}
          {/* </div>
        </div> */}
      </div>
    </>
  );
};
